import React, { useState } from 'react';
import { X, AlertTriangle, CheckCircle, Calendar, MessageSquare, FileText } from 'lucide-react';
import axios from 'axios';
import './DesistementModal.css';

const DesistementModalAdmin = ({ etudiant, onClose, onSuccess }) => {
  const [formDesistement, setFormDesistement] = useState({
    statut: etudiant?.desistement?.statut || false,
    raison: etudiant?.desistement?.raison || '',
    commentaire: etudiant?.desistement?.commentaire || ''
  });
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const raisonsDesistement = [
    'Raisons financières',
    'Problèmes de santé',
    'Changement d\'orientation',
    'Obtention d\'une autre opportunité',
    'Éloignement géographique',
    'Raisons familiales',
    'Niveau trop élevé/difficile',
    'Insatisfaction de la formation',
    'Problèmes administratifs',
    'Autre'
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormDesistement(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formDesistement.statut && !formDesistement.raison) {
      setMessage('❌ La raison du désistement est obligatoire');
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.patch(
        `     https://vmi1977988.contaboserver.net/api2/admin/etudiants/${etudiant._id}/desistement`,
        formDesistement,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      setMessage(`✅ ${response.data.message}`);

      setTimeout(() => {
        onSuccess(response.data.data);
        onClose();
      }, 1500);

    } catch (err) {
      setMessage('❌ Erreur: ' + (err.response?.data?.message || 'Erreur inconnue'));
    } finally {
      setLoading(false);
    }
  };

  const handleReactiver = async () => {
    if (!window.confirm('Êtes-vous sûr de vouloir réactiver cet étudiant ?')) return;

    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.patch(
        `     https://vmi1977988.contaboserver.net/api2/admin/etudiants/${etudiant._id}/reactiver`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      setMessage(`✅ ${response.data.message}`);

      setTimeout(() => {
        onSuccess(response.data.data);
        onClose();
      }, 1500);

    } catch (err) {
      setMessage('❌ Erreur: ' + (err.response?.data?.message || 'Erreur inconnue'));
    } finally {
      setLoading(false);
    }
  };

  if (!etudiant) return null;

  const formatDate = (isoDate) => {
    if (!isoDate) return 'N/A';
    const date = new Date(isoDate);
    return date.toLocaleDateString('fr-FR');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content desistement-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>
            <AlertTriangle size={24} className="header-icon" />
            Gestion du Désistement
          </h3>
          <button className="btn-fermer-modal" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="etudiant-info-banner">
          <div className="etudiant-avatar">
            {etudiant.image ? (
              <img src={`     https://vmi1977988.contaboserver.net${etudiant.image}`} alt="étudiant" />
            ) : (
              <div className="avatar-placeholder">
                {etudiant.prenom?.charAt(0)}{etudiant.nomDeFamille?.charAt(0)}
              </div>
            )}
          </div>
          <div className="etudiant-details">
            <h4>{etudiant.prenom} {etudiant.nomDeFamille}</h4>
            <p>{etudiant.email}</p>
            <p>{etudiant.filiere} - Niveau {etudiant.niveau}</p>
          </div>
          {etudiant.desistement?.statut && (
            <div className="status-badge desiste">
              <AlertTriangle size={16} />
              Désisté
            </div>
          )}
        </div>

        {etudiant.desistement?.statut && (
          <div className="desistement-existant">
            <h5>
              <FileText size={18} />
              Désistement Actuel
            </h5>
            <div className="desistement-details">
              <div className="detail-row">
                <span className="label">Raison:</span>
                <span className="value">{etudiant.desistement.raison}</span>
              </div>
              {etudiant.desistement.dateDesistement && (
                <div className="detail-row">
                  <span className="label">Date:</span>
                  <span className="value">
                    <Calendar size={14} />
                    {formatDate(etudiant.desistement.dateDesistement)}
                  </span>
                </div>
              )}
              {etudiant.desistement.commentaire && (
                <div className="detail-row">
                  <span className="label">Commentaire:</span>
                  <span className="value">{etudiant.desistement.commentaire}</span>
                </div>
              )}
            </div>
            <button
              onClick={handleReactiver}
              className="btn-reactiver"
              disabled={loading}
            >
              <CheckCircle size={16} />
              Réactiver l'Étudiant
            </button>
          </div>
        )}

        <form onSubmit={handleSubmit} className="desistement-form">
          <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="statut"
                checked={formDesistement.statut}
                onChange={handleChange}
              />
              <span>Marquer comme désisté</span>
            </label>
          </div>

          {formDesistement.statut && (
            <>
              <div className="form-group">
                <label>
                  Raison du Désistement *
                  <span className="required">*</span>
                </label>
                <select
                  name="raison"
                  value={formDesistement.raison}
                  onChange={handleChange}
                  required={formDesistement.statut}
                  className="form-select"
                >
                  <option value="">Sélectionner une raison...</option>
                  {raisonsDesistement.map((raison, index) => (
                    <option key={index} value={raison}>
                      {raison}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>
                  <MessageSquare size={16} />
                  Commentaire / Détails supplémentaires
                </label>
                <textarea
                  name="commentaire"
                  value={formDesistement.commentaire}
                  onChange={handleChange}
                  rows="4"
                  placeholder="Ajoutez des détails supplémentaires sur le désistement..."
                  className="form-textarea"
                />
                <small className="form-hint">
                  Ce commentaire aidera à mieux comprendre les raisons du désistement
                </small>
              </div>

              <div className="warning-box">
                <AlertTriangle size={20} />
                <div>
                  <strong>Attention :</strong> Marquer cet étudiant comme désisté le rendra automatiquement inactif.
                </div>
              </div>
            </>
          )}

          {message && (
            <div className={`message-box ${message.includes('✅') ? 'success' : 'error'}`}>
              {message}
            </div>
          )}

          <div className="modal-actions">
            <button
              type="button"
              onClick={onClose}
              className="btn-annuler"
              disabled={loading}
            >
              Annuler
            </button>
            <button
              type="submit"
              className="btn-enregistrer"
              disabled={loading}
            >
              {loading ? 'Enregistrement...' : 'Enregistrer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DesistementModalAdmin;